import type { Middleware } from '@reduxjs/toolkit';
import historyManager from './historyManager';
import { openRecipeAction } from '@src/app/reducers/workspace/openRecipeReducer';
import { terminateRecipeAction } from '@src/features/Workspace/workspaceSlice';
import { createSnapshot } from './snapshotSerializer';
import { isHistoryEnabled } from './historyToggle';

/**
 * Clears history on recipe open/terminate, and binds the manager to the active recipe id.
 */
export const historyLifecycleMiddleware: Middleware = (storeApi) => (next) => (action) => {
  const result = next(action);

  if (action.type === openRecipeAction.fulfilled.type) {
    const poolId = action.payload.poolId as string | undefined;
    if (poolId) {
      historyManager.clear(poolId);
      // Capture initial baseline snapshot so first mutation can be undone
      if (!isHistoryEnabled()) { return result; }
      try {
        const state = storeApi.getState();
        const snapshot = createSnapshot({ recipePoolId: poolId, state });
        historyManager.capture(poolId, snapshot);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[historyLifecycle] Failed to capture initial snapshot on open:', e);
      }
    }
  } else if (action.type === terminateRecipeAction.fulfilled.type) {
    // Keep state but clear stacks
    // We don't know the pool id here reliably; get it from payload if available
    const poolId = action.meta?.arg?.recipePoolId as string | undefined;
    if (poolId) {
      historyManager.clear(poolId);
    }
  }

  return result;
};

export default historyLifecycleMiddleware;


